<template>
	<div class="try">
    <h1>Metrics</h1>
		<h1>
			Saludo model vue -> {{message}}
		</h1>
		<h1>
			Saludo prop pasado desde rails -> {{greeting}}
		</h1>
		<h1>
			Vuex -> {{ tryVuex }}
		</h1>
    <pie-donut type="pie" :series="series" :labels="labels" :width="width" :chart-options="chartOptions"/>
    <pie-donut type="donut" :series="series" :labels="labels" :width="width" :chart-options="chartOptions"/>
    <pie-donut type="donut" :series="series" :labels="labels" :width="width" :chart-options="chartOptionsSemiDonut"/>
		<button type="button" class="btn btn-primary" @click="changeValue">Cambiar valor vuex</button>

	</div>
</template>
<script>
import { mapState } from 'vuex'
import PieDonut from './components/pie-donut.vue'
export default {
	name: 'Try',
	props: ['greeting'],
	computed: {
		tryVuex: {
			get () {
				return this.$store.state.tryVuex
			},
			set (value){
				this.$store.commit('changeTryVuex', value)
			}
		},
	},
	methods: {
		changeValue() {
			this.tryVuex = 'Cambio de valor prueba.......'
			console.log("changeValue -> " + this.tryVuex)
		}
	},
	data() {
		return {
      type: 'pie',
      series: [44, 55, 13, 43, 22],
      width: 380,
      chartOptions: {
        labels: ['Laborales', 'Personales', 'Team C', 'Team D', 'Team E'],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 400
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      },
      chartOptionsSemiDonut: {
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 90,
            offsetY: 10
          }
        },
        grid: {
          padding: {
            bottom: -80
          }
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      },
			message: 'Hola Mundo Vue'
		}
	},
	created () {
	  console.log(this.$store);
	},
  components: {
    'pie-donut': PieDonut,
  },
}
</script>
<style scoped>
 	.login-footer {
	 background-color: #e6e6e6;
 }
</style>